import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["goalSelector", "checkbox"]
  
  connect() {
    // Console log for debugging
    console.log("SDG Goals controller connected")
  }
  
  toggle(event) {
    const goalSelector = event.currentTarget
    const goal = goalSelector.dataset.goal
    const checkbox = this.checkboxTargets.find(cb => cb.value === goal)
    const overlay = goalSelector.querySelector('.goal-overlay')
    
    // Toggle checkbox
    checkbox.checked = !checkbox.checked
    
    // Toggle filter
    if (checkbox.checked) {
      overlay.classList.remove('opacity-50')
      overlay.classList.add('opacity-0')
    } else {
      overlay.classList.remove('opacity-0')
      overlay.classList.add('opacity-50')
    }
  }
}